
import { store } from '../store/configureStore'
import { selectors as environmentSelectors } from '../store/environment'

const generateUrl = <T>(url: string, params: T, includeBase = true): string => {
    if (params !== null) {
        Object.getOwnPropertyNames(params).forEach(key => {
            if (Array.isArray(params[key])) {
                var queryString = params[key].map((item, index) => {
                    var param = key + "=" + item;
                    return index + 1 === params[key].length ? param : param + "&";
                }).join('');
                url = url.replace('{' + key + '}', queryString);
            } else {
                if (params[key] === null || params[key] === undefined) {
                    url = url.replace('{' + key + '}', '');
                    return;
                }
                url = url.replace('{' + key + '}', params[key]);
            }
        });
    }

    return includeBase ? environmentSelectors.getBaseUrl(store.getState()) + url : url;
}

export default generateUrl
